import React, { type ReactNode, createContext, useContext, useMemo } from 'react'

import { type TenantData, getTenantData } from '../../../../utils/TenantDataHelpers'

type TenantContextValue = TenantData

const TenantContext = createContext<TenantContextValue | undefined>(undefined)

interface TenantProviderProps {
  tenant: string
  children: ReactNode
}

export const TenantProvider: React.FC<TenantProviderProps> = ({ tenant, children }) => {
  const tenantData = useMemo(() => getTenantData(tenant), [tenant])

  return <TenantContext.Provider value={tenantData}>{children}</TenantContext.Provider>
}

export const useTenant = (): TenantContextValue => {
  const context = useContext(TenantContext)
  if (!context) {
    throw new Error('useTenant must be used within a TenantProvider')
  }
  return context
}
